import { type WorldEdits, WorldEditsSavedSchema } from '@shefira/shared';
import { z } from 'zod';

import { serverHttpUrl } from '../net/session.js';

/**
 * Send the edits to the server (ADR 0022), which checks them and writes
 * them into the repository. The answer is a line for the editor's panel.
 */
const RefusalSchema = z.object({ details: z.array(z.string()).min(1) });

export async function saveWorldEdits(
  token: string,
  edits: WorldEdits,
): Promise<{ saved: boolean; message: string }> {
  let response: Response;
  try {
    response = await fetch(`${serverHttpUrl()}/admin/world-edits`, {
      method: 'POST',
      headers: { 'content-type': 'application/json', authorization: `Bearer ${token}` },
      body: JSON.stringify(edits),
    });
  } catch {
    return { saved: false, message: 'Serveur injoignable.' };
  }
  const body: unknown = await response.json().catch(() => null);
  if (response.ok && WorldEditsSavedSchema.safeParse(body).success) {
    return {
      saved: true,
      message:
        'Enregistré dans world-edits.json. Le serveur redémarre sur les retouches : recharge si la connexion tombe.',
    };
  }
  const refusal = RefusalSchema.safeParse(body);
  const reason = refusal.success ? refusal.data.details[0] : `erreur ${String(response.status)}`;
  return { saved: false, message: `Refusé : ${reason ?? ''}` };
}
